import { render } from "./Stack.vue?vue&type=template&id=f7799798&scoped=true"
import script from "./Stack.vue?vue&type=script&lang=js"
export * from "./Stack.vue?vue&type=script&lang=js"

import "./Stack.vue?vue&type=style&index=0&id=f7799798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7799798"]])

export default __exports__